export function stopScroll(disable) {
    document.body.style.overflow = disable ? "hidden" : "";
}
